import React, { lazy } from 'react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-brand-base pt-10 pb-12 px-6" data-id="element-193">
      <div className="max-w-[1060px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-start" data-id="element-194">
        <div className="text-center md:text-left" data-id="element-195">
          <div className="mb-4 text-center md:text-left" data-id="element-196">
            <div className="inline-flex items-center gap-2.5 bg-brand-green/10 border-[1.5px] border-brand-green text-brand-green font-display text-xs font-semibold tracking-[1.5px] py-2 px-5 rounded-full uppercase" data-id="element-197">
              🌿 MEGAPACK CUERPO NUEVO DESPUÉS DE LOS 40™
            </div>
          </div>

          <p className="text-[11px] text-brand-muted mb-4 md:mb-5 text-center md:text-left" data-id="element-198">
            <a href="https://www.impulsodigitalstore.com" className="text-white/45 hover:text-white/70 transition-colors" data-id="element-199">
              www.impulsodigitalstore.com
            </a>{' '}
            &nbsp;·&nbsp;
            <a href="#" className="text-white/45 hover:text-white/70 transition-colors" data-id="element-200">
              @impulsodigital.store
            </a>{' '}
            &nbsp;·&nbsp;
            <a href="mailto:soporte@impulsodigitalstore.com" className="text-white/45 hover:text-white/70 transition-colors" data-id="element-201">
              soporte@impulsodigitalstore.com
            </a>
          </p>

          <h1 className="font-display text-[28px] sm:text-[3.8vw] md:text-[50px] font-bold text-white mb-2.5 leading-[1.15] uppercase" data-id="element-202">
            <span className="text-brand-green" data-id="element-203">
              Adelgazá, desinflamá y desinchate
              <br data-id="element-204" />
              hasta 5kg en los primeros 7 días.
            </span>
            <br data-id="element-205" />
            <span className="text-brand-red" data-id="element-206">
              Sin dieta, sin remedios, sin gimnasio.
            </span>
          </h1>

          <p className="font-display text-xl font-bold text-white tracking-[1px] mb-4 uppercase" data-id="element-207">
            Listo. Desde hoy.
          </p>

          <div className="w-full bg-[#1a1a1a] border-2 border-dashed border-[#333] rounded-xl flex flex-col items-center justify-center gap-2 text-[#444] text-[13px] text-center p-4 h-[320px] max-w-[420px] mx-auto md:mx-0 mb-4 md:hidden" data-id="element-208">
            <span className="text-[28px]" data-id="element-209">📦</span>
            <p data-id="element-210">[ Mockup del producto ]</p>
            <p className="text-[11px] text-[#333]" data-id="element-211">
              Reemplazar con: &lt;img src="URL_DEL_MOCKUP" loading="lazy"&gt;
            </p>
          </div>

          <p className="text-sm text-white/75 mb-4 leading-[1.65]" data-id="element-212">
            El método que reactiva el metabolismo de la menopausia desde la
            alimentación — comiendo 3 a 4 veces por día, de verdad.
          </p>

          <span className="inline-block bg-brand-green/10 border border-brand-green text-brand-green font-display text-xs font-semibold tracking-[2px] py-1.5 px-4 rounded mb-5 uppercase" data-id="element-213">
            ✦ Sistema N°1 de alimentación metabólica para mujeres +40 ✦
          </span>

          <div className="flex flex-wrap gap-2 mb-5 justify-center md:justify-start" data-id="element-214">
            {['📄 100% PDF', '⚡ Acceso en 5 min', '📚 6 Tomos', '🎁 6 Bonos'].map(chip => <span key={chip} className="bg-white/5 border border-white/10 text-white/80 text-xs py-1 px-3.5 rounded-full" data-id="element-215">
                {chip}
              </span>)}
          </div>

          <button onClick={scrollToPricing} className="block w-full md:w-auto bg-brand-green text-white font-display text-lg font-bold tracking-[1px] py-4 px-7 rounded-lg text-center uppercase border-none cursor-pointer transition-transform hover:-translate-y-0.5 mb-2.5 shadow-[0_0_28px_rgba(0,200,83,0.3)]" data-id="element-216">
            🔥 QUIERO MI MEGAPACK AHORA
          </button>

          <p className="text-xs text-brand-muted text-center md:text-left" data-id="element-217">
            ✅ Garantía 7 días &nbsp;·&nbsp; 🔒 Pago 100% seguro &nbsp;·&nbsp;
            💳 MercadoPago
          </p>
        </div>

        <div className="hidden md:flex items-center justify-center" data-id="element-218">
          <div className="w-full bg-[#1a1a1a] border-2 border-dashed border-[#333] rounded-xl flex flex-col items-center justify-center gap-2 text-[#444] text-[13px] text-center p-4 h-[400px] max-w-[480px]" data-id="element-219">
            <span className="text-[28px]" data-id="element-220">📦</span>
            <p data-id="element-221">[ Mockup grande desktop ]</p>
            <p className="text-[11px] text-[#333]" data-id="element-222">
              Reemplazar con: &lt;img src="URL_DEL_MOCKUP" loading="lazy"&gt;
            </p>
          </div>
        </div>
      </div>
    </section>;
}